import { useMutation } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { apiClient } from 'src/services/api/client';

const PATH = 'api/landlord/emails/associate-email';

type ApiResponse = {
  alias: string;
  domain: string;
}

export const useAssociateEmailAddress = () => {
    return useMutation<ApiResponse, IStandardErrorResponse>(
        async () => {
            try {
                return await apiClient(PATH, { method: 'post' }).json<ApiResponse>();
            } catch (error) {
                if (isEmailResponse(error)) {
                    return error;
                }

                throw error;
            }
        }
    );
};

/**
 * If the user has already associated an email address, the email will be returned as an error response.
 */
const isEmailResponse = (error: unknown): error is ApiResponse => {
    if ((error as ApiResponse).alias && (error as ApiResponse).domain) {
        return true;
    }

    return false;
};